// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"e014e70e","158":"7dda3261","560":"b55c73fb"}[chunkId] + ".chunk.js";
};